import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { useMonthActions } from "@website/ui/datepicker/components/month-actions/month-actions.hook";
import styles from "@website/ui/datepicker/components/month-actions/month-actions.module.scss";
import { MonthActionsPropertiesType } from "@website/ui/datepicker/components/month-actions/month-actions.types";
import { MONTH_NAMES } from "@website/ui/datepicker/constanst";
import { getNativeGregorianMonthName } from "@website/ui/datepicker/datepicker.utils";
import { numberConvert } from "@website/utils/number-convert";
import { FC, Fragment } from "react";
export const MonthActions: FC<MonthActionsPropertiesType> = properties => {
  const $ = _c(14);
  const {
    calendarLocale: t0,
    showDates,
    type,
    view
  } = properties;
  const calendarLocale = t0 === undefined ? "gregorian" : t0;
  const {
    showPreviousMonthButtonProperties,
    showNextMonthButtonProperties
  } = useMonthActions(properties);
  const t1 = `${styles.container} ${view === "mobile" && type === "popover" ? styles["container-popover__mobile"] : type === "popover" && view !== "mobile" ? styles["container-popover"] : styles["container-flat"]} ${styles["rtl" || "ltr"]}`;
  let t2;
  if ($[0] !== showPreviousMonthButtonProperties) {
    t2 = <Button {...showPreviousMonthButtonProperties} className={styles["month-button"]} />;
    $[0] = showPreviousMonthButtonProperties;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== calendarLocale || $[3] !== showDates || $[4] !== type || $[5] !== view) {
    t3 = showDates ? showDates.map((item, index) => <Fragment key={`${item.year}-${item.month}`}>{index > 0 ? <div className={styles["month-name-divider"]} /> : null}<div className={`${styles["month-name"]} ${type === "popover" ? styles["month-name-popover"] : view === "mobile" ? styles["month-name-flat__mobile"] : styles["month-name-flat"]}`}>{(MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[item.month - 1]}{" "}{numberConvert(item.year, {
          numberOnly: true,
          locale: "fa"
        })}{calendarLocale === "gregorian" ? <span className={styles["month-name-native"]} dir="ltr">({getNativeGregorianMonthName(item.year, item.month)})</span> : null}</div></Fragment>) : null;
    $[2] = calendarLocale;
    $[3] = showDates;
    $[4] = type;
    $[5] = view;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showNextMonthButtonProperties) {
    t4 = <Button {...showNextMonthButtonProperties} className={styles["month-button"]} />;
    $[7] = showNextMonthButtonProperties;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};